import { Debug } from "@otto-ec/global-debug";

// Export Debug functionality to global namespace.
window.o_global = window.o_global || {};
window.o_global.debug = window.o_global.debug || Debug;
